'use strict';

import { initCarousel } from "../../../_scripts/helpers";

export default class ModalCarousel {
  constructor($selector, selfInit = true, config) {
    this.breakpoints = config.breakpoints;
    this.$selector = $selector;
    this.carouselOptions = {
      dots: false,
      infinite: true,
      adaptiveHeight: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      appendArrows: $("[data-carousel-arrows]", this.$selector),
      responsive: [
        {
          breakpoint: this.breakpoints.lgDesktop,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
          },
        },
        {
          breakpoint: this.breakpoints.desktop,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        }
      ]
    };

    if (selfInit) this.init();
  }

  init() {
    const carousel = initCarousel(
      $("[data-carousel]", this.$selector),
      this.carouselOptions
    );

    let resizeTimer;
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        //Close off modal in mobile view
        if ($(window).width() <= 1023) {
          $("body").removeClass("no-scroll");
          $("body > [data-modal]").hide();
          $("[data-modal-content]", $("body > [data-modal]")).remove();
        }
      }, 300);
    });

    
  }
}
